<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>

            </b-col>
            <b-col>

            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-tabs fill>
                    <b-tab active>
                        <template slot="title">
                            {{Core.Definition.getDefinition('Billets ouverts')}}
                        </template>
                        <DynamicCardList
                                ref="dynamicCardList"
                                caption="Liste des billets ouverts"
                                :searchFormStructure="dataSearchFormStructure"
                                :columns="dataColumns"
                                :edit="dataEdit"
                                root="/support/open-tickets">
                        </DynamicCardList>
                    </b-tab>
                    <b-tab>
                        <template slot="title">
                            {{Core.Definition.getDefinition('Billets fermés')}}
                        </template>
                        <DynamicCardList
                                ref="dynamicCardList"
                                caption="Liste des billets fermés"
                                :searchFormStructure="dataSearchFormStructure"
                                :columns="dataColumns"
                                :edit="dataEdit"
                                root="/support/closed-tickets">
                        </DynamicCardList>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import DynamicCardList from '../../../components/DynamicCardList'
    export default {
        name: 'TicketList',
        components: {
            DynamicCardList,
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Sujet'),
                        key: 'subject',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date créée'),
                        key: 'creationDate',
                        sortable: true,
                        type: 'date'
                    },
                    {
                        label: Core.Definition.getDefinition('Date modifiée'),
                        key: 'modificationDate',
                        sortable: true,
                        type: 'date'
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'subject'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'subject',
                            type: 'text',
                            label: Core.Definition.getDefinition('Sujet'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/systeme/support/billets/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
